export const isTypographyToken = (obj) => {
    if (typeof obj === 'object' && obj !== null) {
        const o = obj;
        return (typeof o.fontFamily === 'string' &&
            typeof o.letterSpacing === 'string' &&
            typeof o.fontWeight === 'string' &&
            typeof o.textDecoration === 'string' &&
            typeof o.fontSize === 'string' &&
            typeof o.lineHeight === 'string' &&
            typeof o.fontStretch === 'string');
    }
    return false;
};
//# sourceMappingURL=is-typography-token.js.map